import { Component, OnInit, ViewChild } from '@angular/core';
import { SearchComponent } from '../../../base/search/search.component';
import { HtmlContentSearchResult } from '../../../../models/net/result/html-content-search-result';
import { SearchMarqueeComponent } from '../../../fragments/search-marquee/search-marquee.component';
import { AppService } from '../../../../services/app.service';
import { SessionService } from '../../../../services/session/session.service';
import { HtmlContentSearchRequest } from '../../../../models/net/request/html-content-search-request';
import { SearchRequestEnvelope } from '../../../../models/net/envelope/search-request-envelope';
import { SearchPreference } from '../../../../models/data/app-core/search-preference';
import { SearchRequestTypeEnum } from '../../../../enums/search-request-type-enum';
import { EmailMessageService } from '../../../../services/email-messages/email-message.service';
import { EmailMessageSearchResult } from '../../../../models/net/result/email-message-search-result';
import { EmailMessageEnvelope } from '../../../../models/net/envelope/email-message-envelope';
import { EmailMessageSearchRequest } from '../../../../models/net/request/email-message-search-request';

@Component({
    selector: 'app-html-contents',
    templateUrl: './email-messages.component.html',
    styleUrls: ['./email-messages.component.css', '../../../../app.component.css']
})

export class EmailMessagesComponent extends SearchComponent implements OnInit {

    public displayedColumns: string[] = ["Avatar", "FromEmailAddress", "ToEmailAddresses", "CcEmailAddresses", "BccEmailAddresses", "Subject", "SentOnUTC", "CreatedOnUTC", "Delete"];
    public override searchResult: EmailMessageSearchResult[] = [];
    public searchRequestEnvelopes: EmailMessageEnvelope[] = [];
    public searchRequestTypeName: string = "SearchRequestEnvelope";
    public searchRequestTileComponentTypeName: string = "SearchTileComponent";

    @ViewChild("searchMarquee") searchMarquee!: SearchMarqueeComponent;

    public constructor(public override appService: AppService, public override sessionService: SessionService, public override itemService: EmailMessageService) {

        super(appService, sessionService, itemService, "emailmessage", "EmailMessage");
        super.searchRequestTypeEnum = SearchRequestTypeEnum.HtmlContentSearchRequest;
    }

    public override ngOnInit(): void {

        super.ngOnInit();

        this.isSearchMarqueeDisabled = false;
    }

    public ngAfterViewInit(): void {

        this.searchMarquee!.runSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            const searchRequest: EmailMessageSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            this.runSearch(searchRequest);
        });

        this.searchMarquee!.runSavedSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            var resourceSearchRequest: EmailMessageSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            if (resourceSearchRequest) {

                this.runSearch(resourceSearchRequest);
            }
        });
    }

    public override handleSearchPreference(searchPreference: SearchPreference): void {

        if (searchPreference.SearchPreferenceId > 0) {

            if (searchPreference.DefaultSearchRequestId) {

                this.searchMarquee!.isSavedSearchMode = true;

                this.searchMarquee!.setDefaultSearchRequestId(searchPreference.DefaultSearchRequestId);

                if (searchPreference.IsRunDefaultSearchOnLoad) {

                    this.searchMarquee!.searchRequested();
                }
            }

        } else {

            this.searchMarquee!.isSavedSearchMode = false;
        }

        this.isSearchMarqueeDisabled = false;
    }

    public override getItemIndexFromSearchResult = (id: number): number | undefined => {

        const result = this.searchResult.map((i: EmailMessageSearchResult) => i.EmailMessageId).indexOf(id, 0);

        return result;
    }

    public runSearch = (searchRequest: EmailMessageSearchRequest): void => {

        this.searchRequest = searchRequest;

        this.search();
    }
}
